import { createApp } from "vue";
import App from "./SiteWideApp.vue";
import { setWebpackPublicPath } from "../../shared/js/webpack-utils";
import i18n from "./i18n";

setWebpackPublicPath();

const app = createApp(App);
app.use(i18n);
app.mount("#mf-site-wide");
